export default __webpack_public_path__ + "static/media/accessories.e57eeae7.png";